import { z } from 'zod'
import { InterestVariableEnum } from '../../../@shared/domain/enums/InterestVariable.enum'
import { SmartProcessingAudit } from '../../domain/entities/SmartProcessingAudit'

export const SmartProcessingAuditSchema = z
	.object({
		variavel_de_interesse: z.enum(InterestVariableEnum),
		modelo_ajustado_latex: z.string(),
		coeficientes_modelo_ajustado: z.array(z.number()),
		r2_ajustado: z.number(),
		erro: z.number(),
		erro_percentual: z.number(),
		// Tolerante de proposito: uma variavel sem grafico gerado ainda tem
		// equacao, coeficientes e metricas para auditar. Derrubar o item inteiro
		// por causa do PNG esconderia o resto.
		identificador_grafico_residuos: z.string().nullish(),
	})
	.transform(
		(data) =>
			new SmartProcessingAudit(
				data.variavel_de_interesse,
				data.modelo_ajustado_latex,
				data.coeficientes_modelo_ajustado,
				data.r2_ajustado,
				data.erro,
				data.erro_percentual,
				data.identificador_grafico_residuos ?? '',
			),
	)
